var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar-title',[_c('v-img',{attrs:{"src":_vm.isMobile ? _vm.mobileSrc : _vm.src,"height":_vm.isMobile ? _vm.mobileHeight : _vm.height,"width":_vm.isMobile ? _vm.mobileWidth : _vm.width,"contain":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }